<template>
  <div class="inputs">
    <SessionContent></SessionContent>
    <div class="home-icons">
      <b-row class="justify-content-sm-center boxes icon-buttons ">
        <b-col cols="12" sm="auto" v-for="campaign in campaigns" :key="'campaign-' + campaign.id" @click="selectCampaign(campaign)" class="choice">
          <div class="d-none d-sm-block box campaign-box">
            <img :src="campaign.logo.file" alt="" block variant="primary"/>
            <p v-html="campaign.name"></p>
          </div>
          <b-button block
                    class="d-sm-none btn btn-default btn-session gutters mob-home-btn"
                    variant="primary">
            <img :src="campaign.logo.file" alt="" block variant="primary" class="mob-home-btn-icon"/>
            <p v-html="campaign.name" class="new-btns"></p>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SessionContent from './SessionContent'

export default {
  name: 'SelectCampaign',
  components: {SessionContent},
  props: {
    input: Object
  },
  data: function() {
    return {
      campaigns: []
    }
  },
  methods: {
    goBack: function() {
      this.$emit('back') // we're viewing the product list, go back to the previous step
    },
    selectCampaign: function(campaign) {
      this.$emit('select', {campaign: campaign.id}) // product selected, pass to the parent
    }
  },
  created() {
    this.$store.commit('busy')
    this.$store.dispatch('get_switchable_campaigns')
      .then(campaigns => {
        this.campaigns = campaigns
        this.$store.commit('ready')
      })
      .catch(err => {
        this.$store.commit('critical_error', err)
      })
  }
}
</script>

<style scoped>

</style>
